<template>
  <div>
    <HeaderPeople
      titulo="Personas en el Estado"
      desc="Corresponde a la cobertura de instituciones que elaboran Balance de Gestión Integral"
      showYearSelect="true"
    />

    <div class="container some">
      <h3 class="outstanding"></h3>
      <Commentary />
    </div>

    <Collapse />
  </div>
</template>

<script>
import HeaderPeople from "../../../components/cabecera/HeaderPeople.vue";
import Commentary from "../../../components/commentary/Commentary.vue";
import Collapse from "./collapse/Collapse.vue";
export default {
  components: {
    HeaderPeople,
    Commentary,
    Collapse,
  },
};
</script>

<style scoped>
.graphic {
  margin-bottom: 10px;
}

.toast {
  background: blue !important;
}

.some {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-direction: row;
  margin-bottom: 25px;
}
</style>
